enum Message {
  SET_MESSAGE_INITIALIZE = 'SET_MESSAGE_INITIALIZE',
  SET_MESSAGE_DIALOG = 'SET_MESSAGE_DIALOG',
  REMOVE_MESSAGE_DIALOG = 'REMOVE_MESSAGE_DIALOG',
  SET_MESSAGE_CONFIRM = 'SET_MESSAGE_CONFIRM',
  REMOVE_MESSAGE_CONFIRM = 'REMOVE_MESSAGE_CONFIRM',
  SET_MESSAGE_SNACK = 'SET_MESSAGE_SNACK',
  REMOVE_MESSAGE_SNACK = 'REMOVE_MESSAGE_SNACK'
}

export default Message;
